import mod from "-!./PencilSquare.js?vue&type=script&lang=js&"; export default mod; export * from "-!./PencilSquare.js?vue&type=script&lang=js&"